export default __webpack_public_path__ + "img/man-22fc5b7b.png";